var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11043_98845",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11043_98845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14C9.78333 14 10.0208 13.9042 10.2125 13.7125C10.4042 13.5208 10.5 13.2833 10.5 13V12C10.5 11.7167 10.5958 11.4792 10.7875 11.2875C10.9792 11.0958 11.2167 11 11.5 11H13.5V11.8C13.5 12.0333 13.6 12.1917 13.8 12.275C14 12.3583 14.1833 12.3167 14.35 12.15L16.15 10.35C16.1833 10.3167 16.2333 10.2 16.3 10C16.3 9.96667 16.25 9.85 16.15 9.65L14.35 7.85C14.1833 7.68333 14 7.64167 13.8 7.725C13.6 7.80833 13.5 7.96667 13.5 8.2V9H11.5C10.6667 9 9.95833 9.29167 9.375 9.875C8.79167 10.4583 8.5 11.1667 8.5 12V13C8.5 13.2833 8.59583 13.5208 8.7875 13.7125C8.97917 13.9042 9.21667 14 9.5 14ZM4.5 18C3.95 18 3.47917 17.8042 3.0875 17.4125C2.69583 17.0208 2.5 16.55 2.5 16V5C2.5 4.45 2.69583 3.97917 3.0875 3.5875C3.47917 3.19583 3.95 3 4.5 3H20.5C21.05 3 21.5208 3.19583 21.9125 3.5875C22.3042 3.97917 22.5 4.45 22.5 5V16C22.5 16.55 22.3042 17.0208 21.9125 17.4125C21.5208 17.8042 21.05 18 20.5 18H4.5ZM4.5 16H20.5V5H4.5V16ZM2.5 21C2.21667 21 1.97917 20.9042 1.7875 20.7125C1.59583 20.5208 1.5 20.2833 1.5 20C1.5 19.7167 1.59583 19.4792 1.7875 19.2875C1.97917 19.0958 2.21667 19 2.5 19H22.5C22.7833 19 23.0208 19.0958 23.2125 19.2875C23.4042 19.4792 23.5 19.7167 23.5 20C23.5 20.2833 23.4042 20.5208 23.2125 20.7125C23.0208 20.9042 22.7833 21 22.5 21H2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShare);
export default __webpack_public_path__ + "static/media/ScreenShare.64ba5dbbecfa45216abac6ba2bd01830.svg";
export { ForwardRef as ReactComponent };